// extracted by mini-css-extract-plugin
export default {"gap_20":"UserAccountComponentData_gap_20__y0-lK"};